import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/ka5.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon3.svg";
import navIcon3 from "../assets/img/imggit.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">

              <a href="https://www.linkedin.com/in/kevin-alvear-244753187/" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon1} alt="" />
                </a>
                <a href="https://github.com/KelvinAlvear19" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon3} alt="" />
                </a>
                <a href="https://www.instagram.com/kevinalvear1915/" target="_blank" rel="noopener noreferrer">
                  <img src={navIcon2} alt="" />
                </a>
            </div>
            <p>Copyright 2024. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}